import _isEmpty from "lodash/isEmpty";
import { getAvailableQuantity } from 'swag-common/business-logic/giveaway/calculate-available-quantity';
const ONE_SIZE = 'ONE_SIZE';
export function isOneSize(sizeValue) {
  return sizeValue === ONE_SIZE;
}
export const getGiveawayProductColors = (product, byColorValue = false) => {
  const colors = product === null || product === void 0 ? void 0 : product.variants.reduce((colorsMap, {
    colorValue,
    colorName,
    quantity,
    inProductionQuantity,
    inReserveQuantity,
    parentId,
    colorVariantId,
    _id,
    sizeIndex,
    sizeSettings
  }) => {
    var _colorsMap$key, _colorsMap$key2;
    const key = byColorValue ? colorValue : colorName;
    const nextSizesAndVariantIds = ((_colorsMap$key = colorsMap[key]) === null || _colorsMap$key === void 0 ? void 0 : _colorsMap$key.sizesAndVariantIds) || [];
    let sizeValue = ONE_SIZE;
    let sizes = [ONE_SIZE];
    if (!_isEmpty(sizeSettings)) {
      sizeValue = (sizeSettings === null || sizeSettings === void 0 ? void 0 : sizeSettings.options[sizeIndex]) || ONE_SIZE;
      sizes = (sizeSettings === null || sizeSettings === void 0 ? void 0 : sizeSettings.options) || [ONE_SIZE];
    }
    nextSizesAndVariantIds.push({
      variantId: _id,
      sizeValue,
      availableQuantity: getAvailableQuantity({
        quantity,
        inProductionQuantity,
        inReserveQuantity
      })
    });
    colorsMap[key] = {
      colorValue,
      sizes,
      colorName,
      parentId,
      colorVariantId,
      sizesAndVariantIds: nextSizesAndVariantIds,
      availableQuantity: (((_colorsMap$key2 = colorsMap[key]) === null || _colorsMap$key2 === void 0 ? void 0 : _colorsMap$key2.availableQuantity) || 0) + getAvailableQuantity({
        quantity,
        inProductionQuantity,
        inReserveQuantity
      })
    };
    return colorsMap;
  }, {});
  return colors;
};